<template>
  <ButtonRectangle
    priority="low-white"
    size="small"
    iconRight="plusRectangle"
    @click="click"
    >{{ level }}</ButtonRectangle
  >
</template>

<script>
import ButtonRectangle from '@/components/ButtonRectangle';

export default {
  props: {
    level: {
      type: String,
      required: true
    }
  },
  components: {
    ButtonRectangle
  },
  methods: {
    click() {
      this.$emit('click', this.level, '');
    }
  }
};
</script>
